module.exports = __webpack_public_path__ + "static/img/AGT_logo.0f6ca32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/AGT_logo.png
// module id = cMDg
// module chunks = 0